<template>
  <div ref="menu" class="relative inline-block">
    <!-- Trigger -->
    <button
      @click="toggle"
      class="px-3 py-2 bg-sky-500 text-white rounded-lg"
    >
      <slot name="trigger">Toggle</slot>
    </button>

    <!-- Conținut cu animație -->
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-show="open"
        :class="[
          'absolute mt-2 bg-white shadow-lg rounded-lg p-3',
          align === 'right' ? 'right-0' : 'left-0',
          width
        ]"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, provide } from 'vue'

const props = defineProps({
  align: {
    type: String,
    default: 'left',
    validator: (value) => ['left', 'right'].includes(value)
  },
  width: {
    type: String,
    default: 'w-48'
  },
  closeOnSelect: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select'])

const open = ref(false)
const menu = ref(null)

function toggle() {
  open.value = !open.value
}

function handleClickOutside(event) {
  if (menu.value && !menu.value.contains(event.target)) {
    open.value = false
  }
}

// Funcție expusă la copii prin provide()
function selectItem(value) {
  emit('select', value)
  if (props.closeOnSelect) {
    open.value = false
  }
}

provide('dropdownSelect', selectItem)

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>